import request from "../utils/request";

export function listWaterDeposits(params) {
  // is_paginated=0 page page_size
  return request({
    url: "/api/orgs/geology/water-deposits/",
    method: "get",
    params
  });
}

export function detailWaterDeposits(params) {
  // is_paginated=0 page page_size
  return request({
    url: `/api/orgs/geology/water-deposits/${params}`,
    method: "get"
  });
}
export function listWaterIntakes(params) {
  // is_paginated=0 page page_size
  return request({
    url: "/api/orgs/geology/water-intakes/",
    method: "get",
    params
  });
}

export function detailWaterIntakes(params) {
  // is_paginated=0 page page_size
  return request({
    url: `/api/orgs/geology/water-intakes/${params}/`,
    method: "get"
  });
}
export function listApprovedSites(params) {
  // is_paginated=0 page page_size
  return request({
    url: "/api/orgs/geology/approved-sites/",
    method: "get",
    params
  });
}

export function detailApprovedSites(params) {
  // is_paginated=0 page page_size
  return request({
    url: `/api/orgs/geology/approved-sites/${params}/`,
    method: "get"
  });
}
